
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { Assignment } from "@/inspection/shared/models/Assignment";
import { checklistReportOption } from "@/inspection/report/models/ReportFormatDefinitions";
import { InspectionSettingsContainer } from "@/inspection/shared/settings/InspectionSettingsContainer";
import { SelectionItem } from "@/shared/form/FormTypes";
import { UserSettings } from "@/storage/UserSettings";

@Component<CreateReportButton>({
  components: {}
})
export default class CreateReportButton extends Vue {
  @Prop({ type: Object, default: () => new Assignment() })
  protected readonly assignment!: Assignment;

  protected get availableReports() {
    const reports: SelectionItem[] = [];

    if (this.assignment.checklist?.type === "water_meter_inspection") {
      reports.push({
        text: "Wassermesserkontrolle",
        value: "water_meter_inspection"
      });
    } else {
      // the checklist's report format determines its report, so this replaces
      // the standard PDF report rather than adding a second option
      reports.push(checklistReportOption(this.checklistReportFormat));
      reports.push({
        text: "CSV-Datei (Excel)",
        value: "csv"
      });

      if (this.testClient) {
        reports.push({
          text: "Wohnungsübergabeprotokoll",
          value: "move_out_checklist"
        });
      }
    }

    return reports;
  }

  /**
   * The logical report format of the assignment's checklist, looked up in the
   * cached checklist catalog by the checklist type — the catalog key.
   */
  protected get checklistReportFormat() {
    return InspectionSettingsContainer.checklists.getChecklist(
      this.assignment.checklist?.type ?? ""
    )?.report_type;
  }

  protected get testClient() {
    return (
      UserSettings.getClientId() === "17" || UserSettings.getClientId() === "10"
    );
  }

  protected reportSelected(type: string) {
    const suffix = type === "move_out_checklist" ? "-new" : "";

    if (type === "csv") {
      this.assignment.generateCsv();
    } else {
      this.$router.push({
        name: "edit-report" + suffix,
        params: {
          assignmentId: this.assignment.id?.toString() ?? ""
        },
        query: {
          reportType: type
        }
      });
    }
  }

  protected downloadReport() {
    window.open(this.assignment.generateReportResponse.result, "_blank");
    this.assignment.generateReportResponse.clear();
  }
}
